import React from 'react';
import classNames from 'classnames/bind';

import PropTypes from 'prop-types';
import { Card } from '@beef/smart-kit';

// Components
import { ExtraActiveBlock } from '../ExtraActiveBlock';
import { extraInfoShape } from '../../../propTypes';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ActiveOfferWrap = ({ extraInfo, children }) => (
  <div className={cn('offers-wrapper')}>
    <div className={cn('offers-wrapper__container')}>
      <Card
        withHover
        className={cn('offers-wrapper__item')}
      >
        {children}
      </Card>
    </div>
    <ExtraActiveBlock {...extraInfo} />
  </div>
);

ActiveOfferWrap.propTypes = {
  extraInfo: extraInfoShape,
  children: PropTypes.object,
};

export { ActiveOfferWrap };
